import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SettingConstants {
  static readonly RequireConfirmedEmail = 'Abp.Identity.SignIn.RequireConfirmedEmail';

  static readonly MorphingEnabled = 'VoiceMorphing.Enabled';

  static readonly InteractionManagementEnabled = 'InteractionManagement.Enabled';

  static readonly EmotionEnabled = 'AnalyticsFeatures.Emotion.Enabled';
  static readonly SentimentEnabled = 'AnalyticsFeatures.Sentiment.Enabled';
  static readonly GenderEnabled = 'AnalyticsFeatures.Gender.Enabled';
  static readonly TextCorrectionEnabled = 'AnalyticsFeatures.TextCorrection.Enabled';
  static readonly AcousticEnabled = 'AnalyticsFeatures.Acoustic.Enabled';
}
